/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Card, Table, Row, Col, Tag, Button, Spin } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { postAPI, displayMessage } from "../../../utils/common";
import { ERROR_MSG_TYPE } from "../../../constants/messages";
import { LAUNDRY_OUT_BY_ID } from "../../../constants/api";

const { Content } = Layout;

function LaundryOutView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchDetail();
  }, []);

  const fetchDetail = () => {
    setLoading(true);

    postAPI(
      LAUNDRY_OUT_BY_ID,
      { id },
      (res) => {
        if (res.status === true) {
          setData(res.data);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
          navigate("/laundry/out");
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch laundry out detail");
      }
    );
  };

  const columns = [
    {
      title: "Item Name",
      dataIndex: ["item", "name"],
    },
    {
      title: "Qty Sent",
      dataIndex: "qty_sent",
    },
    {
      title: "Rate",
      render: (_, row) => `₹ ${row.rate}`,
    },
    {
      title: "Amount",
      render: (_, row) => `₹ ${row.qty_sent * row.rate}`,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Laundry Out Details"
          extra={
            <Button onClick={() => navigate(-1)} type="primary" ghost>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            {data && (
              <>
                {/* HEADER INFO */}
                <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                  <Col span={8}>
                    <b>Vendor:</b> {data.vendor?.name}
                  </Col>
                  <Col span={8}>
                    <b>Out Date:</b>{" "}
                    {dayjs(data.out_date).format("DD MMM YYYY")}
                  </Col>
                  <Col span={8}>
                    <b>Status:</b>{" "}
                    <Tag color={data.status === "pending" ? "orange" : "green"}>
                      {data.status.toUpperCase()}
                    </Tag>
                  </Col>
                </Row>

                {/* ITEMS TABLE */}
                <Table
                  columns={columns}
                  dataSource={data.items}
                  pagination={false}
                  rowKey={(row) => row.id}
                />

                {/* TOTAL */}
                <Row style={{ marginTop: 20 }}>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <h3>Total Amount: ₹ {data.total_amount}</h3>
                  </Col>
                </Row>
              </>
            )}
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default LaundryOutView;
